<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app
      ><v-toolbar-title class="ml-0 pl-3"> Snap Drive </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                 Reset Password
                </div>
              </div>
            </v-card-title>
            <v-form ref="form" v-model="form" class="pa-4 pt-6">
              <v-text-field
                outline
                v-model="model.username"
                :rules="[rules.email]"
                label="Email address"
                type="email"
                @keyup.enter="sendEmail"
              ></v-text-field>

              <v-subheader style="padding-top: 15px"
                    ><router-link to="/"
                      >Login</router-link
                    ></v-subheader>

              <v-btn
                @click="sendEmail"
                :loading="loading"
                block
                color="secondary"
                dark
                >Send Email</v-btn
              >
            </v-form>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>


export default {
  title: "Reset Password",
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: ""
    },
    socket: null,
    dialog: false,
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      password: (v) =>
        !!(v || "").match(/^.{4,15}$/) || "Password must be 8-15 characters.",
      required: (v) => !!v || "This field is required",
    },
  }),
  // mounted() {
  //   this.axios
  //     .get(this.api.ACTIONS.GET_LOGIN_IDENTFIER)
  //     .then(({ data: { data: qrCode } }) => {
  //       QRCode.toDataURL(qrCode, {
  //         errorCorrection: "high",
  //         version: 4,
  //       }).then((data) => {
  //         this.qrCode = data;
  //         this.socket = io(this.api.SOCKET.GUESTS, {
  //           transportOptions: {
  //             polling: {
  //               extraHeaders: {
  //                 authorization: qrCode,
  //               },
  //             },
  //           },
  //         });
  //         this.socket.on("authenticate", async (token) => {
  //           await this.$store.dispatch("validateToken", token);
  //           // const user = this.$store.state.user;
  //           let next = this.$route.query.next || "/dashboard";
  //           // if (this.airportAgency(user.roles))
  //           //     next = 'airport/create';
  //           window.getApp.$emit("APP_LOGIN_SUCCESS");
  //           await this.$router.push(next);
  //         });
  //       });
  //     });
  // },
  methods: {
    async sendEmail() {
      if (!this.$refs.form.validate())
        return;
      this.error = false;
      this.loading = true;
      console.log(this.model);
      this.axios
        .post(this.api.ACTIONS.RESET_PASSWORD_EMAIL, { ...this.model, provider: "users" })
        .then(({ data }) => {
          
          window.getApp.$emit("RESET_EMAIL_SENT");
          this.$router.push('reset-password');
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", "Check your info", "red");
          }
        })
        .then(() => (this.loading = false));
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
